var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"allocation-status",class:{ '-hidden': !_vm.isModified, '-show-mobile': _vm.showOnMobile }},[_c('i',{staticClass:"fi-pencil"}),_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }